const constants = {};
constants.api = {};

constants.api.analytics = {};
constants.api.analytics.SOUND_SKIP = '/api/analytics/sound/skip';
constants.api.analytics.SOUND_LAUNCH = '/api/analytics/sound/launch';

export default constants;